export default __webpack_public_path__ + "static/kids-reading-ae2b4fca72b813274cd3d3bd75f7ff8f.jpeg";